import store from '../Redux/Store/store';
import { ImageData } from '../Redux/Actions/Atlas/images.action';

const checkImageRepeatedName = (image: ImageData, imageAtlas?: ImageData[]) => {
    const imageData = imageAtlas ? imageAtlas : store.getState().imagesAtlas;
    return imageData.find(compImage => image.name === compImage.name && image.id !== compImage.id);
}

export default checkImageRepeatedName;